<template>
  <Modal
    v-if="!embedded"
    :value="value"
    :title="modalTitle"
    class-name="vc-add-resource-modal"
    width="560"
    :footer-hide="true"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
    @input="$emit('input', $event)"
  >
    <div class="vc-add-resource-body">
      <div class="vc-add-resource-field">
        <span class="vc-form-label">类型</span>
        <div class="vc-add-resource-type vc-add-resource-type--llm">
          <DeploymentUnitOutlinedIcon :size="18" class="vc-add-resource-type__icon" />
          <span>大模型</span>
        </div>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">名称</span>
        <Input v-model="form.name" placeholder="给资源取个名字" :maxlength="60" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">供应商</span>
        <Select v-model="form.provider" transfer placeholder="请选择">
          <Option v-for="item in providers" :key="item" :value="item">{{ item }}</Option>
        </Select>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">url</span>
        <Input v-model="form.url" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">api_key</span>
        <Input v-model="form.api_key" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">描述</span>
        <Input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="简单描述资源的功能，这将展示给用户"
        />
      </div>
    </div>
    <div class="vc-add-resource-footer">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" class="vc-add-resource-confirm" :loading="submitting" @click="handleConfirm">
        确认
      </Button>
    </div>
  </Modal>
  <div v-else class="vc-add-resource-embedded">
    <div class="vc-add-resource-body">
      <div class="vc-add-resource-field">
        <span class="vc-form-label">类型</span>
        <div class="vc-add-resource-type vc-add-resource-type--llm">
          <DeploymentUnitOutlinedIcon :size="18" class="vc-add-resource-type__icon" />
          <span>大模型</span>
        </div>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">名称</span>
        <Input v-model="form.name" placeholder="给资源取个名字" :maxlength="60" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">供应商</span>
        <Select v-model="form.provider" transfer placeholder="请选择">
          <Option v-for="item in providers" :key="item" :value="item">{{ item }}</Option>
        </Select>
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">url</span>
        <Input v-model="form.url" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">api_key</span>
        <Input v-model="form.api_key" placeholder="请输入" />
      </div>
      <div class="vc-add-resource-field">
        <span class="vc-form-label vc-form-label--required">描述</span>
        <Input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="简单描述资源的功能，这将展示给用户"
        />
      </div>
    </div>
    <div class="vc-add-resource-footer">
      <Button type="primary" class="vc-add-resource-confirm" :loading="submitting" @click="handleConfirm">
        确认
      </Button>
    </div>
  </div>
</template>

<script>
import {
  LLM_RESOURCE_PROVIDERS,
  resolveDefaultModelForLlmProvider,
} from '../../utils/tripleAccessHelpers'
import DeploymentUnitOutlinedIcon from '../shared/DeploymentUnitOutlinedIcon.vue'

const createEmptyForm = () => ({
  name: '',
  provider: LLM_RESOURCE_PROVIDERS[0] || '阿里云通义千问 QWen',
  url: '',
  api_key: '',
  description: '',
})

export default {
  name: 'AddLlmModelModal',
  components: { DeploymentUnitOutlinedIcon },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    modelItem: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      providers: LLM_RESOURCE_PROVIDERS,
      form: createEmptyForm(),
      submitting: false,
    }
  },
  computed: {
    isEditMode() {
      return !!(this.modelItem && this.modelItem.id)
    },
    modalTitle() {
      return this.isEditMode ? '编辑模型' : '添加资源'
    },
  },
  methods: {
    fillFormFromModel(modelItem) {
      if (!modelItem || typeof modelItem !== 'object') {
        this.form = createEmptyForm()
        return
      }
      this.form = {
        name: String(modelItem.name != null ? modelItem.name : ''),
        provider: String(modelItem.provider != null ? modelItem.provider : '').trim()
          || LLM_RESOURCE_PROVIDERS[0]
          || '',
        url: String(modelItem.url != null ? modelItem.url : ''),
        api_key: String(modelItem.api_key != null ? modelItem.api_key : ''),
        description: String(modelItem.description != null ? modelItem.description : ''),
      }
    },
    onVisibleChange(visible) {
      if (visible) {
        this.fillFormFromModel(this.modelItem)
        this.submitting = false
      }
    },
    handleCancel() {
      this.$emit('input', false)
    },
    validateForm() {
      const name = String(this.form.name != null ? this.form.name : '').trim()
      const provider = String(this.form.provider != null ? this.form.provider : '').trim()
      const url = String(this.form.url != null ? this.form.url : '').trim()
      const apiKey = String(this.form.api_key != null ? this.form.api_key : '').trim()
      const description = String(this.form.description != null ? this.form.description : '').trim()
      if (!name) {
        this.$Message.warning('请填写资源名称')
        return null
      }
      if (!provider) {
        this.$Message.warning('请选择供应商')
        return null
      }
      if (!url) {
        this.$Message.warning('请填写 url')
        return null
      }
      if (!apiKey) {
        this.$Message.warning('请填写 api_key')
        return null
      }
      if (!description) {
        this.$Message.warning('请填写描述')
        return null
      }
      const payload = {
        name,
        provider,
        url,
        api_key: apiKey,
        description,
        model: resolveDefaultModelForLlmProvider(provider),
      }
      if (this.isEditMode) {
        payload.id = String(this.modelItem.id).trim()
        const existingModel = String(this.modelItem.model != null ? this.modelItem.model : '').trim()
        if (existingModel) payload.model = existingModel
      }
      return payload
    },
    handleConfirm() {
      const payload = this.validateForm()
      if (!payload) return
      this.submitting = true
      this.$emit('confirm', payload)
      this.submitting = false
      if (this.embedded && !this.isEditMode) {
        this.form = createEmptyForm()
      } else if (!this.embedded) {
        this.$emit('input', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './shared.scss';

.vc-add-resource-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.vc-add-resource-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vc-add-resource-type {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #0066a1;
  border-radius: 4px;
  color: #0066a1;
  font-size: 14px;
  background: #f5faff;
  width: fit-content;

  &__icon {
    color: #0066a1;
  }

  &--llm {
    border-color: #5668f0;
    color: #5668f0;
    background: #f5f7ff;

    .vc-add-resource-type__icon,
    .deployment-unit-outlined-icon {
      color: #5668f0;
    }
  }
}

.vc-add-resource-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 4px;
}

.vc-add-resource-confirm {
  min-width: 88px;
}
</style>
